var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlipLeft = function SvgFlipLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "#677F89",
    fill: "#677F89",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 15,
    transform: "matrix(1 0 0 -1 2 19)",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5172 16H17.4828C17.3047 16 17.2154 15.7846 17.3414 15.6586L19.8586 13.1414C19.9367 13.0633 20.0633 13.0633 20.1414 13.1414L22.6586 15.6586C22.7846 15.7846 22.6953 16 22.5172 16Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21V23ZM16 21H18V23H16V21ZM19 20V16H21V20H19ZM18 21C18.5523 21 19 20.5523 19 20H21C21 21.6569 19.6569 23 18 23V21Z",
    stroke: "none"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlipLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d3ceee021dbd6506bd8c52c5ed4e42f0.svg";